<template>
  <header class="header">
    <nav class="nav-container">
      <!-- 汉堡按钮 -->
      <button class="hamburger-btn" @click="toggleMenu" v-show="isMobile">
        <svg class="hamburger-icon" viewBox="0 0 24 24" width="24" height="24">
          <path
            d="M3 6h18M3 12h18M3 18h18"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
          />
        </svg>
      </button>
      <!-- 移动端菜单面板 -->
      <transition name="slide">
        <div class="mobile-menu" v-show="isMobile && isMenuOpen">
          <ul class="mobile-nav-menu">
            <li class="mobile-nav-item" @click="navigateTo('/')">首页</li>
            <li
              class="mobile-nav-item dropdown"
              @click="toggleMobileDropdown('company')"
            >
              走进企业
              <svg
                class="arrow-icon"
                :class="{ rotated: mobileDropdownOpen.company }"
                viewBox="0 0 24 24"
                width="16"
                height="16"
              >
                <path
                  d="M9 5l7 7-7 7"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
              </svg>
            </li>
            <transition name="fade">
              <ul
                class="mobile-dropdown-menu"
                v-show="mobileDropdownOpen.company"
              >
                <li
                  v-for="item in companyItems"
                  :key="item.label"
                  class="mobile-dropdown-item"
                  @click="navigateTo(item.route, item.sectionId)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </transition>
            <li
              class="mobile-nav-item dropdown"
              @click="toggleMobileDropdown('product')"
            >
              匠心产品
              <svg
                class="arrow-icon"
                :class="{ rotated: mobileDropdownOpen.product }"
                viewBox="0 0 24 24"
                width="16"
                height="16"
              >
                <path
                  d="M9 5l7 7-7 7"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
              </svg>
            </li>
            <transition name="fade">
              <ul
                class="mobile-dropdown-menu"
                v-show="mobileDropdownOpen.product"
              >
                <li
                  v-for="item in productItems"
                  :key="item.label"
                  class="mobile-dropdown-item"
                  @click="navigateTo(item.route, item.sectionId)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </transition>
            <li class="mobile-nav-item" @click="navigateTo('/field')">
              应用领域
            </li>
            <li
              class="mobile-nav-item dropdown"
              @click="toggleMobileDropdown('about')"
            >
              关于羊驼
              <svg
                class="arrow-icon"
                :class="{ rotated: mobileDropdownOpen.about }"
                viewBox="0 0 24 24"
                width="16"
                height="16"
              >
                <path
                  d="M9 5l7 7-7 7"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
              </svg>
            </li>
            <transition name="fade">
              <ul
                class="mobile-dropdown-menu"
                v-show="mobileDropdownOpen.about"
              >
                <li
                  v-for="item in aboutItems"
                  :key="item.label"
                  class="mobile-dropdown-item"
                  @click="navigateTo(item.route, item.sectionId)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </transition>
            <li
              class="mobile-nav-item dropdown"
              @click="toggleMobileDropdown('contact')"
            >
              联系我们
              <svg
                class="arrow-icon"
                :class="{ rotated: mobileDropdownOpen.contact }"
                viewBox="0 0 24 24"
                width="16"
                height="16"
              >
                <path
                  d="M9 5l7 7-7 7"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
              </svg>
            </li>
            <transition name="fade">
              <ul
                class="mobile-dropdown-menu"
                v-show="mobileDropdownOpen.contact"
              >
                <li
                  v-for="item in contactItems"
                  :key="item.label"
                  class="mobile-dropdown-item"
                  @click="navigateTo(item.route, item.sectionId)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </transition>
            <div class="mobile-search-box">
              <input
                type="text"
                placeholder="探索更多"
                class="mobile-search-input"
                v-model="searchText"
                @keydown="handleKeyDown"
              />
              <button class="mobile-search-btn" @click="handleSearch">
                <img
                  src="/imgs/start/images/fangdajing_03.png"
                  alt="搜索"
                  class="search-icon"
                />
              </button>
            </div>
          </ul>
        </div>
      </transition>
      <!-- 桌面端菜单 -->
      <ul class="nav-menu" v-show="!isMobile">
        <li
          :class="['nav-item', 'dropdown', { active: isActive('/') }]"
          @mouseenter="showDropdown('index')"
          @mouseleave="hideDropdown('index')"
          @click="navigateTo('/')"
        >
          首页
        </li>
        <li
          :class="['nav-item', 'dropdown', { active: isActive('/company') }]"
          @mouseenter="showDropdown('company')"
          @mouseleave="hideDropdown('company')"
          @click="navigateTo('/company')"
        >
          走进企业
          <svg class="arrow-icon" viewBox="0 0 24 24" width="16" height="16">
            <path
              d="M9 5l7 7-7 7"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
            />
          </svg>
          <transition name="fade">
            <ul class="dropdown-menu" v-show="dropdownVisible.company">
              <li
                v-for="item in companyItems"
                :key="item.label"
                class="dropdown-item"
                @click.stop="navigateTo(item.route, item.sectionId)"
              >
                {{ item.label }}
              </li>
            </ul>
          </transition>
        </li>
        <li
          :class="['nav-item', 'dropdown', { active: isActive('/product') }]"
          @mouseenter="showDropdown('product')"
          @mouseleave="hideDropdown('product')"
          @click="navigateTo('/product')"
        >
          匠心产品
          <svg class="arrow-icon" viewBox="0 0 24 24" width="16" height="16">
            <path
              d="M9 5l7 7-7 7"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
            />
          </svg>
          <transition name="fade">
            <ul class="dropdown-menu" v-show="dropdownVisible.product">
              <li
                v-for="item in productItems"
                :key="item.label"
                class="dropdown-item"
                @click.stop="navigateTo(item.route, item.sectionId)"
              >
                {{ item.label }}
              </li>
            </ul>
          </transition>
        </li>
      </ul>
      <div class="logo-container">
        <img
          src="/imgs/start/images/header-logo_03.png"
          alt="AIT Logo"
          class="logo"
        />
      </div>
      <ul class="nav-menu">
        <li
          :class="['nav-item', 'dropdown', { active: isActive('/field') }]"
          @mouseenter="showDropdown('field')"
          @mouseleave="hideDropdown('field')"
          @click="navigateTo('/field')"
        >
          应用领域
          <!-- <svg class="arrow-icon" viewBox="0 0 24 24" width="16" height="16"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" fill="none"/></svg>
                    <transition name="fade">
                        <ul class="dropdown-menu" v-show="dropdownVisible.field">
                            <li v-for="item in fieldItems" :key="item.label" class="dropdown-item" @click.stop="navigateTo(item.route)">{{ item.label }}</li>
                        </ul>
                    </transition> -->
        </li>
        <li
          :class="['nav-item', 'dropdown', { active: isActive('/about') }]"
          @mouseenter="showDropdown('about')"
          @mouseleave="hideDropdown('about')"
          @click="navigateTo('/about')"
        >
          关于羊驼
          <svg class="arrow-icon" viewBox="0 0 24 24" width="16" height="16">
            <path
              d="M9 5l7 7-7 7"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
            />
          </svg>
          <transition name="fade">
            <ul class="dropdown-menu" v-show="dropdownVisible.about">
              <li
                v-for="item in aboutItems"
                :key="item.label"
                class="dropdown-item"
                @click.stop="navigateTo(item.route, item.sectionId)"
              >
                {{ item.label }}
              </li>
            </ul>
          </transition>
        </li>
        <li
          :class="['nav-item', 'dropdown', { active: isActive('/contact') }]"
          @mouseenter="showDropdown('contact')"
          @mouseleave="hideDropdown('contact')"
          @click="navigateTo('/contact')"
        >
          联系我们
          <svg class="arrow-icon" viewBox="0 0 24 24" width="16" height="16">
            <path
              d="M9 5l7 7-7 7"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
            />
          </svg>
          <transition name="fade">
            <ul class="dropdown-menu" v-show="dropdownVisible.contact">
              <li
                v-for="item in contactItems"
                :key="item.label"
                class="dropdown-item"
                @click.stop="navigateTo(item.route, item.sectionId)"
              >
                {{ item.label }}
              </li>
            </ul>
          </transition>
        </li>
        <!-- <div class="search-box">
          <input
            type="text"
            placeholder="搜索更多"
            class="search-input"
            v-model="searchText"
            @keydown="handleKeyDown"
          />
          <button class="search-btn" @click="handleSearch">
            <img
              src="/imgs/start/images/fangdajing_03.png"
              alt="搜索"
              class="search-icon"
            />
          </button>
        </div> -->
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: "HeaderView",
  components: {},
  data() {
    return {
      searchText: "",
      isMenuOpen: false,
      isMobile: false,
      mobileDropdownOpen: {
        company: false,
        product: false,
        field: false,
        about: false,
        contact: false,
      },
      dropdownVisible: {
        index: false,

        company: false,
        product: false,
        field: false,
        about: false,
        contact: false,
      },
      indexItems: [
        { label: "首页", route: "/" },
        { label: "产品中心", route: "/products" },
        { label: "应用案例", route: "/cases" },
        { label: "新闻动态", route: "/news" },
      ],

      companyItems: [
        { label: "公司简介", route: "/company", sectionId: "section1" },
        { label: "主营业务", route: "/company", sectionId: "section2" },
        { label: "发展历程", route: "/company", sectionId: "section3" },
        { label: "企业宗旨", route: "/company", sectionId: "section4" },
        { label: "荣誉资质", route: "/company", sectionId: "section5" },
      ],
      productItems: [
        { label: "产品介绍", route: "/product", sectionId: "section1" },
        { label: "加工工艺", route: "/product", sectionId: "section2" },
        { label: "为什么选择羊驼毛", route: "/product", sectionId: "section3" },
      ],
      fieldItems: [
        { label: "工业制造", route: "/fields/manufacturing" },
        { label: "医疗健康", route: "/fields/medical" },
        { label: "智慧城市", route: "/fields/smartcity" },
        { label: "教育培训", route: "/fields/education" },
      ],
      aboutItems: [
        { label: "南美驼科品种", route: "/about", sectionId: "section1" },
        { label: "羊驼毛规格", route: "/about", sectionId: "section2" },
      ],
      contactItems: [
        { label: "联系我们", route: "/contact", sectionId: "section1" },
        { label: "在线留言", route: "/contact", sectionId: "section2" },
      ],
    };
  },
  created() {
    // 组件创建时的初始化逻辑
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    showDropdown(key) {
      this.dropdownVisible[key] = true;
    },
    hideDropdown(key) {
      this.dropdownVisible[key] = false;
    },
    // 搜索事件
    handleSearch() {
      if (this.searchText.trim()) {
        console.log("搜索内容:", this.searchText);
        // 可以添加实际的搜索逻辑
      }
    },
    // 键盘回车事件
    handleKeyDown(event) {
      if (event.key === "Enter") {
        this.handleSearch();
      }
    },
    // 导航跳转方法
    navigateTo(route, sectionId) {
      if (!route) return;
      // 若已在目标路由，直接返回，避免重复 push
      if (this.$route.path === route) {
        // 如果已经在目标路由且有sectionId，直接滚动到对应section
        if (sectionId) {
          this.scrollToSection(sectionId);
        }
        return;
      }
      // 跳转到目标路由
      this.$router.push(route).then(() => {
        // 路由跳转成功后，如果有sectionId则滚动到对应section
        if (sectionId) {
          // 使用nextTick确保DOM已更新，然后增加额外延迟等待页面完全渲染
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToSection(sectionId);
            }, 300);
          });
        }
      }).catch(() => {});
      // 关闭所有下拉菜单
      Object.keys(this.dropdownVisible).forEach((key) => {
        this.dropdownVisible[key] = false;
      });
      // 移动端关闭菜单
      if (this.isMobile) {
        this.isMenuOpen = false;
      }
    },
    // 滚动到指定section（带重试机制）
    scrollToSection(sectionId, retryCount = 0) {
      const section = document.getElementById(sectionId);
      if (section) {
        const offsetTop = section.offsetTop - 80; // 减去header高度
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      } else if (retryCount < 5) {
        // 如果找不到section，重试最多5次，每次间隔200ms
        setTimeout(() => {
          this.scrollToSection(sectionId, retryCount + 1);
        }, 200);
      }
    },
    // 切换汉堡菜单
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    // 切换移动端子菜单
    toggleMobileDropdown(key) {
      this.mobileDropdownOpen[key] = !this.mobileDropdownOpen[key];
    },
    // 检测是否移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 576;
      if (!this.isMobile) {
        this.isMenuOpen = false;
      }
    },
    // 判断当前路由是否匹配
    isActive(path) {
      return this.$route.path === path;
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #ffffff;
  padding: 25px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: relative;
  /* position: absolute; */
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.nav-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: clamp(320px, 90vw, 1500px);
  margin: 0 auto;
  padding: 0 2vw;
  /* padding:0 3vw 0 0; */
  gap: clamp(1.5rem, 4vw, 6rem);
}

.nav-menu {
  display: flex;
  flex: 1 1 45%;
  /* justify-content: space-between; */
  justify-content: space-around;
  list-style: none;
  margin: 0;
  padding: 0;
  /* gap: clamp(1.5rem, 4vw, 5rem); */
}

.nav-item {
  min-width: clamp(60px, 5vw, 72px);
  font-size: clamp(14px, 1.2vw, 18px);
  font-weight: 400;
  color: #333333;
  cursor: pointer;
  transition: color 0.3s ease;
  position: relative;
  text-align: center;
}

.nav-item:hover {
  color: #ff7a00;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.nav-item:hover .arrow-icon,
.dropdown-menu[style*="display: block"] + .arrow-icon {
  transform: rotate(90deg);
}

.nav-item.active {
  color: #ff7a00;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  display: block;
  height: clamp(40px, 5vw, 63px);
  width: auto;
  object-fit: contain;
}

.search-box {
  display: flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 5px 10px;
  /* background-color: #f9f9f9; */
}

.search-input {
  border: none;
  background: transparent;
  outline: none;
  padding: 0.4em 0.8em;
  font-size: clamp(12px, 1vw, 14px);
  color: #666666;
  width: clamp(80px, 10vw, 120px);
}

.search-input::placeholder {
  color: #999999;
}

.search-btn {
  border: none;
  background: transparent;
  outline: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-icon {
  display: block;
  width: 16px;
  height: 16px;
  object-fit: contain;
}

/* 下拉菜单样式 */
.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 150%;
  left: -22%;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  list-style: none;
  margin: 0;
  padding: 8px 0;
  min-width: 120px;
  z-index: 1000;
  text-align: center;
}

.dropdown-item {
  padding: 8px 16px;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  white-space: nowrap;
}

.dropdown-item:hover {
  background-color: #fff5eb;
  color: #ff7a00;
}

/* 下拉菜单过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
/* 汉堡按钮 */
.hamburger-btn {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 1001;
}

.hamburger-icon {
  display: block;
  color: #333;
}

/* 移动端菜单面板 */
.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 12px 0;
}

/* 确保header容器的层叠上下文正确 */
.header {
  position: relative;
  z-index: 1000;
}

.mobile-nav-menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mobile-nav-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: color 0.3s ease;
}

.mobile-nav-item:hover {
  color: #ff7a00;
}

.mobile-dropdown-menu {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fafafa;
}

.mobile-dropdown-item {
  padding: 10px 32px;
  font-size: 14px;
  color: #555;
  cursor: pointer;
  transition: color 0.3s ease;
}

.mobile-dropdown-item:hover {
  color: #ff7a00;
}

.mobile-search-box {
  display: flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 5px 10px;
  margin: 12px 16px 0;
}

.mobile-search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  padding: 0.4em 0.8em;
  font-size: 14px;
  color: #666;
}

.mobile-search-input::placeholder {
  color: #999;
}

.mobile-search-btn {
  border: none;
  background: transparent;
  outline: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 下拉箭头旋转 */
.mobile-nav-item .arrow-icon {
  transition: transform 0.3s ease;
}

.mobile-nav-item .arrow-icon.rotated {
  transform: rotate(90deg);
}

/* 移动端面板滑动动画 */
.slide-enter-active,
.slide-leave-active {
  transition: max-height 0.3s ease;
  max-height: 600px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .nav-container {
    flex-wrap: wrap;
    gap: 20px;
  }

  .nav-menu {
    gap: 20px;
  }

  .logo {
    max-height: 35px;
  }
}

@media (max-width: 768px) {
  .header {
    padding: 0;
  }
  .nav-menu {
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .nav-item {
    font-size: 13px;
    min-width: auto;
  }

  .logo {
    max-height: 30px;
  }

  .search-box {
    margin-top: 10px;
  }

  .search-input {
    width: 100px;
    font-size: 13px;
  }

  .arrow-icon {
    display: none;
  }
}

@media (max-width: 576px) {
  .nav-container {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 16px;
    position: relative;
  }
  .nav-menu {
    display: none !important;
  }

  .hamburger-btn {
    display: block;
  }

  .logo-container {
    margin: 0 auto;
  }

  .logo {
    max-height: 32px;
  }
}
</style>
